import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GenericConfirmModalComponent } from '@shared/modals/generic-confirm-modal/generic-confirm-modal.component';
import {
  OverviewGettingStartedDataModel
} from '@shared/overview/overview-getting-started-checklist/overview-getting-started-data.model';
import { zbpIconNames } from '@shared/zbp-icon/zbp-icon-names';
import { first } from 'rxjs';

@Component({
  selector: 'zbp-overview-getting-started-checklist',
  templateUrl: './overview-getting-started-checklist.component.html',
  styleUrls: ['./overview-getting-started-checklist.component.scss'],
  standalone: false
})
export class OverviewGettingStartedChecklistComponent implements OnInit {

  @Input() checkListData: Array<OverviewGettingStartedDataModel> = [];

  /**
   * starts on -1 to make logic incrementing logic cleaner in method
   */
  private currentOnLoadIndex = -1;

  constructor(
    private ngbModal: NgbModal,
  ) {
  }

  ngOnInit() {
    // kick off recursive modals
    this.nextOnLoadModal();
  }

  private nextOnLoadModal(): void {
    // always go to the next index at start
    this.currentOnLoadIndex++;
    if (this.checkListData.length <= this.currentOnLoadIndex) {
      // ran out of check list items to check for popup settings
      // short circuit the method
      return;
    }
    const item = this.checkListData[this.currentOnLoadIndex];
    if (item?.onLoadModalCriteria) {
      // this item has an onload custom modal setting and meets criteria
      if (item.onLoadCustomModal) {
        item.onLoadCustomModal();
        this.nextOnLoadModal();
      } else if (item.onLoadGenericModal) {
        // this item has an onload generic modal setting and meets criteria
        const modalRef = GenericConfirmModalComponent.open(this.ngbModal, item.onLoadGenericModal);
        modalRef.closed.pipe(first()).subscribe(() => {
          // popup confirm button clicked, do the checklist action
          this.clickItem(item);
        });
        modalRef.dismissed.pipe(first()).subscribe(() => {
          // popup canceled or closed, try to play next onload modal
          this.nextOnLoadModal();
        });
      }
    } else {
      // this checklist item does not have a popup, try to play next onload modal
      this.nextOnLoadModal();
    }
  }

  clickItem(item: OverviewGettingStartedDataModel) {
    if (item && item.onClick) {
      item.onClick();
    }
  }

  getIcon(isChecked: boolean): string {
    return isChecked
      ? zbpIconNames.check_mark
      : zbpIconNames.ellipse;
  }

}
